import { store, blId } from "../socket/config.js";

const TITLE_INPUT_SELECTOR = '[class*="project-title-input_title-field"]';

const lockInput = (input) => {
    if (!input.readOnly) input.readOnly = true;
};

export const lockProjectTitle = () => {
    store.dispatch({
        type: "projectTitle/SET_PROJECT_TITLE",
        title: blId,
    });

    const existing = document.querySelector(TITLE_INPUT_SELECTOR);
    if (existing) lockInput(existing);

    const observer = new MutationObserver(() => {
        const input = document.querySelector(TITLE_INPUT_SELECTOR);
        if (input) lockInput(input);
    });
    observer.observe(document.body, { childList: true, subtree: true });
};
